export default __webpack_public_path__ + "static/media/buttons-info-icon.a300ee8a.svg";